import 'styles/templates/reviewers.scss'

import 'scripts/vue/main'

import Vue from 'vue'
import VModal from 'vue-js-modal'

Vue.use(VModal)

window.PSTheme.Vue.Reviewers = new Vue({
  name: 'ReviewersWrapper',
  components: {
    'reviewers': require('../vue/templates/Reviewers.vue').default
  }
}).$mount('.reviewers')
